var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_vm.asset.symbol ? _c('span', {
    staticClass: "symbol"
  }, [_vm._v(_vm._s(_vm.asset.symbol))]) : _c('span', {
    staticClass: "no_symbol"
  })]), _c('p', [_c('router-link', {
    staticClass: "name_id",
    attrs: {
      "to": "/asset/".concat(_vm.asset.id)
    }
  }, [_vm._v(_vm._s(_vm._f("nameOrID")(_vm.asset)))])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }